import React, { Component } from 'react';
// redux
import { compose } from 'redux';
import { submitDailyCheck, getDailyCheck } from '../../redux/reducers/recovery';
import { connect } from 'react-redux';
// hoc
import { withFormik } from 'formik';
import { withRouter } from 'react-router-dom';
// utils
import * as yup from 'yup';
import moment from 'moment';
import { toastResponseErrors } from '../../utils/response';
import _template from 'lodash.template';
// components
import FieldError from '../../components/Form/FieldError';
import Form from '../../components/Form/Form';
import Button from '../../components/Button/Button';
import RadioGroup from '../../components/RadioGroup/RadioGroup';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import Preloader from '../../components/Preloader/Preloader';
// styles
import styles from './DailyCheckIn.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class DailyCheckIn extends Component {
  componentDidMount() {
    this.props.getDailyCheck();
  }

  render() {
    const {
      isSubmitting,
      isLoading,
      values,
      handleSubmit,
      handleChange,
      errors,
      profile_color,
      clocks: { last_attempt_start, start },
    } = this.props;

    const userColor = profile_color || '#33C370';
    const lastTime = last_attempt_start
      ? moment(last_attempt_start).format('MM/DD/YY')
      : moment(start).format('MM/DD/YY');
    const str =
      (this.props.dailyQuestions &&
        this.props.dailyQuestions[0] &&
        this.props.dailyQuestions[0].title) ||
      '';

    const template = _template(str);
    const title = template({ lastTime: lastTime });

    return (
      <PageWrapper centered>
        <h2>Daily Check-in.</h2>
        <Preloader custom isActive={isLoading} />
        <Form className={cx('wrapper')} onSubmit={handleSubmit}>
          <div className="form-control">
            <div className="field-wrapper">
              <p>{title}</p>
              <div className="field-wrapper">
                <RadioGroup
                  name="isCorrectDate"
                  onChange={handleChange}
                  value={values.isCorrectDate}
                  options={[
                    { label: 'Yes', value: 'true' },
                    { label: 'No', value: 'false' },
                  ]}
                />
                <FieldError error={errors.isCorrectDate} touched={true} />
              </div>
            </div>
          </div>
          <div className={cx('button-section')}>
            <Button
              type="submit"
              color={userColor}
              disabled={isSubmitting || isLoading}
              className="mr-30"
            >
              Submit
            </Button>
          </div>
        </Form>
      </PageWrapper>
    );
  }
}

const getAnswers = (dailyQuestions, values) =>
  dailyQuestions.map(({ id }) => ({
    id,
    answer: values.isCorrectDate,
  }));

const enhance = compose(
  connect(
    state => ({
      dailyQuestions: state.recovery.dailyQuestions,
      isLoading: state.recovery.isLoading,
      clocks: state.auth.user.progress.clocks,
      profile_color: state.auth.user.profile_color,
    }),
    { submitDailyCheck, getDailyCheck }
  ),
  withRouter,
  withFormik({
    validationSchema: () =>
      yup.object().shape({
        isCorrectDate: yup.bool().required('Choose answer!'),
      }),
    handleSubmit: (
      values,
      { setSubmitting, props: { submitDailyCheck, dailyQuestions, history } }
    ) => {
      submitDailyCheck({
        resource: { answers: getAnswers(dailyQuestions, values) },
      })
        .then(() => {
          history.push('/dashboard');
        })
        .catch(response => {
          toastResponseErrors(response);
          setSubmitting(false);
        });
    },
    displayName: 'DailyCheckIn',
  })
);

export default enhance(DailyCheckIn);



// WEBPACK FOOTER //
// ./src/containers/DailyCheckIn/DailyCheckIn.jsx